import { createContext } from "react";

const TaskReportContext = createContext();

export default TaskReportContext;
